/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    ReportRepairListShow ({ commit }, data) {
        return axios.post(http + '/reportrepair/show', data).then(res => {
            return res.data
        })
    },
    confirmAssignPersonneldialog ({ commit }, data) {
        return axios.post(http + '/reportrepair/add', data).then(res => {
            return res.data
        })
    },
    personnelShow ({ commit }, data) {
        return axios.post(http + '/reportrepair/get_user', data).then(res => {
            return res.data
        })
    },
    ViewDetails ({ commit }, data) {
        return axios.post('/ocenter/public/index.php/company/reportrepair/show_detail', data).then(res => {
            return res.data
        })
    },
    ExportReportRepair ({ commit }, data) {
        return axios({ method: 'post', url: http + '/reportrepair/show', data: data, responseType: 'blob' }).then(res => {
            return res.data
        })
    },
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/show', data).then(res => {
    //         return res.data
    //     })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const ReportRepairModule = {
    state,
    getters,
    actions,
    mutations
}
export default ReportRepairModule
